var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchVoiceRecognition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C6.80078 0 5 1.80078 5 4V11C5 13.1992 6.80078 15 9 15C11.1992 15 13 13.1992 13 11V4C13 1.80078 11.1992 0 9 0ZM0 11C0 15.6055 3.52344 19.4297 8 19.9375V24H10V19.9375C14.4766 19.4297 18 15.6055 18 11H16C16 14.8555 12.8555 18 9 18C5.14453 18 2 14.8555 2 11H0Z",
    fill: "#62AA51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchVoiceRecognition);
export default __webpack_public_path__ + "static/media/search-voice-recognition.77e82513886bc0884d2bd1a487dac28e.svg";
export { ForwardRef as ReactComponent };